import { FC } from 'react';

interface LoaderIconProps {
  color?: string;
  width?: string;
  height?: string;
}

export const LoaderIcon: FC<LoaderIconProps> = ({ color = 'white', width = '16', height = '16' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path
        opacity="0.25"
        d="M14.6673 8.00234C14.6673 11.6842 11.6825 14.669 8.00065 14.669C4.31875 14.669 1.33398 11.6842 1.33398 8.00234C1.33398 4.32044 4.31875 1.33567 8.00065 1.33567C11.6825 1.33567 14.6673 4.32044 14.6673 8.00234ZM2.66732 8.00234C2.66732 10.9479 5.05513 13.3357 8.00065 13.3357C10.9462 13.3357 13.334 10.9479 13.334 8.00234C13.334 5.05682 10.9462 2.669 8.00065 2.669C5.05513 2.669 2.66732 5.05682 2.66732 8.00234Z"
        fill={color}
      />
      <path
        d="M8.00065 1.99891C8.00065 1.63072 8.29986 1.32879 8.66621 1.36555C9.31337 1.43048 9.94876 1.5899 10.5519 1.83971C11.3607 2.17474 12.0956 2.66581 12.7147 3.28486C13.3338 3.90392 13.8248 4.63885 14.1598 5.44768C14.4097 6.05079 14.5691 6.68619 14.634 7.33335C14.6708 7.6997 14.3688 7.99891 14.0006 7.99891C13.6325 7.99891 13.3383 7.69929 13.2924 7.33397C13.2331 6.86206 13.1108 6.39919 12.928 5.95793C12.66 5.31086 12.2671 4.72292 11.7719 4.22767C11.2766 3.73243 10.6887 3.33958 10.0416 3.07155C9.60036 2.88877 9.1375 2.76649 8.66559 2.70719C8.30027 2.66128 8.00065 2.3671 8.00065 1.99891Z"
        fill={color}
      />
    </svg>
  );
};
